import React from 'react'
import { MAIN_PHONE_NUMBER } from '@constants/index'

import { Back } from '../Back'

import styles from './styles.module.scss'

const LoanCC = () => (
	<article className={styles.article}>
		<Back />
		<h1 className={styles.heading}>Кредитование через Credit.Club</h1>
		<p className={styles.paragraph}>
			Через платформу цифровых решений Credit.Club вы можете получить кредит под залог квартиры:
		</p>
		<ul className={styles.list}>
			<li className={styles.item}>— на сумму до 15 млн;</li>
			<li className={styles.item}>— сроком до 120 месяцев;</li>
			<li className={styles.item}>— низкие ставки;</li>
			<li className={styles.item}>— на любые цели;</li>
		</ul>
		<p className={styles.paragraph}>Подробности можете запросить по номеру {MAIN_PHONE_NUMBER}.</p>
	</article>
)

export default LoanCC
